import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.custom.pageBackground,
    colorScheme: theme.palette.type,
  },
  header: {
    display: 'flex',
  },
  title: {
    flexGrow: 1,
    fontSize: '24px',
    marginBottom: '8px',
    fontWeight: 'bold',
    color: theme.palette.primary.mainBlue,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    gap: '10px',
  },
  hiddenInput: {
    display: 'none',
  },
  progress: {
    marginTop: theme.spacing(2),
  },
  tablePaper: {
    marginTop: theme.spacing(3),
  },
  tableHeader: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  status: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  validStatus: {
    color: theme.palette.custom.diffAddedText,
  },
  invalidStatus: {
    color: theme.palette.custom.diffRemovedText,
  },
}));

export default useStyles;
